import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';

export default class HeaderNavigation {
    init() {
        // навигация для доп-меню страницы
        const headerNavigation = document.querySelector('.js-headerNavigation');

        if (headerNavigation) {
            new Swiper('.js-headerNavigation', {
                loop: false,
                slidesPerView: "auto",
                mousewheel: true,
                breakpoints: {
                    0: {
                        slidesOffsetBefore: 15,
                        slidesOffsetAfter: 50,
                        spaceBetween: 15
                    },
                    768: {
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        spaceBetween: 20,
                    },
                }
            });
        }

        return this;
    }
}
